export const formatAddress = (address1, address2, city, state, zipCode) =>
	`${address1}${
		address2 ? ` ${address2}` : ''
	}, ${city}, ${state} ${zipCode}`;
